import { Box, SxProps, Typography, useTheme, styled, } from "@mui/material";
import { StyleguideSavioColors } from "../../../../configuration/themeSettings";

export const BestViewContainer = styled('div', { label: "bestview-container-bom-io" })
  (({ theme }) => ({
    "& div:nth-of-type(2)": {
      width: 'calc(100vw - 219px)',


      "& div": {
        display: "table",
      },
    },
    flex: "auto",
    overflow: "hidden",
    visibility: "visible",
    display: "flex",
  }))

export const ListThumbnails = styled('ul', { label: "bestview-ListThumbnails" })
  (({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    //height: '100%',
    backgroundColor: StyleguideSavioColors.footerGrey,
    margin: 0,
    width: 153,
    minWidth: 153,
    flex: '0 1px 150px',
    listStyle: 'none',
    padding: 10,
    overflow: 'hidden',
    overflowY: 'auto',
    //height: 'calc(100% - 15px) !important',






  }))

interface LiListThumbnailsProps {
  isSelected?: boolean;
}
export const LiListThumbnails = styled("li", {
  label: "bestview-LiListThumbnails",
})<LiListThumbnailsProps>(({ isSelected, theme }) => ({
  height: 130,
  cursor: "pointer",
  width: 130,
  minWidth: 130,
  minHeight: 130,
  border: "1px solid #C4C6CF",
  backgroundColor: "#fff",
  marginBottom: 7,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  borderColor: isSelected ? StyleguideSavioColors.darkBlue : "#C4C6CF",
  borderStyle: "solid",
  borderWidth: isSelected ? 2 : 1,

  overflow: "hidden",
  "&.current": {
    borderColor: StyleguideSavioColors.mainBlue,
  },
  "&:last-child": {
    marginBottom: 0,
  },
  img: {
    height: "100%",
  },
}));


export const Actions = styled('div', { label: "bestview-Actions" })
  (({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: StyleguideSavioColors.footerGrey,
    margin: 0,
    listStyle: 'none',
    padding: 4,
    overflow: 'hidden',
    overflowY: 'auto',
    flex: "0 1 53px",
    width: 53,
    minWidth: 53,

    "button": {
      color: StyleguideSavioColors.mainBlue,
      width: 45,
      minWidth: 45,

      "svg": {
        width: 29,
        height: 29,
      }
    }
  }))

export const useClasses = (props: any) => {
  const theme = useTheme();
  const classes = {
      selectedThumbnail: {
          borderColor: StyleguideSavioColors.lightGrey,
          borderStyle: "solid",
          borderWidth: "1px",
      } as SxProps,

      customTransform: {
          "& div:nth-of-type(2)": {
              "& div": {
                  display: "table",
              },
          },
      }as SxProps,

      listThumbhUp: {
          height: props.up ? "calc(100% - 176px)" : "100%",
      } as SxProps,
  };

  return classes;
};
